const initialState = {
  // Is Getting Admin Dashboard Credentials
  isGettingAdminDashboardCredentials: false,
  adminDashboardCredentials: {},

  // Is Getting Admin Dashboard Invoice Count By Companies
  adminDashboardInvoiceCountByCompanies: [],
  isGettingAdminDashboardInvoiceCountByCompanies: false,
  totalResultsForInvoice: 0,
  page: 0,
};

const AdminDashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    // Getting Admin Dashboard Credentials
    case "GET_ADMIN_DASHBOARD_CREDENTIALS_REQUEST":
      return {
        ...state,
        isGettingAdminDashboardCredentials: true,
      };
    case "GET_ADMIN_DASHBOARD_CREDENTIALS_SUCCESS":
      return {
        ...state,
        adminDashboardCredentials: action.payload,
        isGettingAdminDashboardCredentials: false,
      };
    case "GET_ADMIN_DASHBOARD_CREDENTIALS_ERROR":
      return {
        ...state,
        isGettingAdminDashboardCredentials: false,
      };
    // Getting Admin Dashboard Invoice Count
    case "GET_ADMIN_DASHBOARD_INVOICE_COUNT_BY_COMPANIES_REQUEST":
      return {
        ...state,
        isGettingAdminDashboardInvoiceCountByCompanies: true,
      };
    case "GET_ADMIN_DASHBOARD_INVOICE_COUNT_BY_COMPANIES_SUCCESS":
      return {
        ...state,
        adminDashboardInvoiceCountByCompanies: action.payload?.data,
        page: action.payload?.page,
        totalResultsForInvoice: action.payload?.totalResults,
        isGettingAdminDashboardInvoiceCountByCompanies: false,
      };
    case "GET_ADMIN_DASHBOARD_INVOICE_COUNT_BY_COMPANIES_ERROR":
      return {
        ...state,
        isGettingAdminDashboardInvoiceCountByCompanies: false,
      };
    default:
      return state;
  }
};

export default AdminDashboardReducer;
